module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-BoldItalic.be35efe6.ttf";